import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';

import { RoleContext } from './RoleContainer';
import RoleSelector from './RoleSelector';

const useStyles = makeStyles(theme => ({
    button: {
        color: 'white !important',
        fontSize: theme.typography.h5.fontSize,
    },

    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        marginTop: theme.spacing(6),
    },

    header: {
        marginBottom: theme.spacing(3)
    },

    requirementsTable: {
        fontSize: 14
    },

    footNotes: {
        fontSize: 11
    },

    container: {
        backgroundColor: 'white',
        maxWidth: 600,

        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(6),
        },

        [theme.breakpoints.down('sm')]: {
            flexGrow: 1,
            padding: theme.spacing(4),
        },

        '& > p,h4': {
            marginBottom: theme.spacing(3),
            textAlign: 'justify',
        },
    },

    roleSelector: {
        marginTop: theme.spacing(4),

        '& > p': {
            textAlign: 'justify',
        },

        [theme.breakpoints.down('xs')]: {
            '& > .MuiFormControl-root': {
                marginTop: theme.spacing(2),
            },
        },

        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',

            '& > .MuiFormControl-root': {
                display: 'block',
                width: '100%',
                maxWidth: 500,
                marginLeft: theme.spacing(4),
            },

            '& .MuiInputBase-root': {
                width: '100%',
                maxWidth: 500,
            },
        },
    },

    root: {
        // backgroundColor: theme.palette.background.default,
        flex: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },

    img: {
        marginBottom: theme.spacing(4),
    },
}))

const LandingPage = () => {
    const classes = useStyles();
    const formStarted = !!window.localStorage.getItem('Alutiiq-PreQualificationPortal/formData');
    const storedUser = window.localStorage.getItem('Alutiiq-PreQualificationPortal/user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const isGuest = user ? user.isGuest : true; 
    const { role, setRole } = React.useContext(RoleContext);

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <div className={classes.root + ' has-background-light'}>
                <Hidden smDown>
                    <div style={{ flex: '1 2' }} />
                </Hidden>
                <Container className={classes.container}>
                    <div className={classes.img}>
                        <img src="/ANC-Final-Logo-Black.gif" height="320" width="170" alt="Alutiiq logo" />
                    </div>

                    <Typography variant="h6" color="primary" align="center" className={classes.header}>
                        Afognak Native Corporation Due Diligence Portal
          </Typography>

                    <Typography variant="body1">
                        Welcome,
          </Typography>

                    <Typography variant="body1">
                    To subcontract with an Alutiiq, LLC. company for a total expected value of $10,000 or more, you must register your company in the Afognak Native Corporation Due Diligence Portal and maintain active registration in System for Award Management at <a href="https://SAM.gov" target="_blank" rel="noopener noreferrer">SAM.gov</a>. Registration should take approximately 15 to 30 minutes. <br/>{isGuest ? 'As a guest user, your form data is session-bound and browser-specific. You may return to your data as long as the same browser is used and its cache is not cleared. However, we recommend completing the form in one session for data consistency.' :  'You may save your progress and complete registration at a later date if necessary.'}
          </Typography>

                    <Typography variant="body1">
                        At the end of the registration process you will be asked to upload pdf files as shown in the chart below.
          </Typography>

                    <Typography variant="body1">
                        Please carefully review the required items. A link to each sample document is provided within the chart. Instructions for uploading pdf documents is provided <a href="/Uploading PDF Documents.pdf" target="_blank" rel="noopener noreferrer">HERE</a>. Registration will not be complete until the required pdf documents are uploaded.
           </Typography>

                    <Typography variant="body1">
                        If you have any questions regarding the portal, or the process, please contact <a href="mailto:duediligence@alutiiq.com">duediligence@alutiiq.com</a>
                    </Typography>

                    <Typography variant="body1">
                        We look forward to doing business with you!
            </Typography>

                    <table className={classes.requirementsTable + ' table table-responsive'}>
                        <thead>
                            <tr>
                                <th>
                                    Subcontractors whose total expected value is  - below $30,000
                            </th>
                                <th>
                                    Subcontractors whose total expected value is -  above $30,000
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Completed W-9 <a target="_blank" href="/Sample W-9.pdf">(see sample HERE)</a></td>
                                <td>Completed W-9 <a target="_blank" href="/Sample W-9.pdf">(see sample HERE)</a></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Workers Compensation EMR <br /> <a target="_blank" href="https://alutiiq.azureedge.net/duediligence/SAMPLE_WorkersComp%20EMR.pdf">(see sample HERE)</a> <sup>Note 1</sup></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Letter of Bondability <br /> <a target="_blank" href="https://alutiiq.azureedge.net/duediligence/SAMPLE_Letter%20of%20Bondability.pdf">(see sample HERE)</a> <sup>Note 2</sup></td>
                            </tr>
                        </tbody>
                    </table>

                    <Typography variant="body1" className={classes.footNotes}>
                        Note 1 - Experience Modification Rate from National Council on Compensation Insurance (NCCI)
                        </Typography>

                    <Typography variant="body1" className={classes.footNotes}>
                        Note 2 – This item only required for subcontractors subject to surety bonding.
                        </Typography>

                    <div className={classes.buttonContainer}>
                        <Button
                            className={classes.button} color="primary" component={Link} size="large" to="/registration/general-info" variant="contained"
                        >
                            {formStarted ? 'Continue' : 'Start'}
                        </Button>
                    </div>
                </Container>
                <Hidden smDown>
                    <div style={{ flex: '2 1' }} />
                </Hidden>
                <div className="has-background-light is-size-7" style={{ padding: '1.5rem', textAlign: 'center' }}>
                    If you have questions about this application or its processing, please contact the Alutiiq Due Diligence Team at <a href="mailto:duediligence@alutiiq.com">DueDiligence@alutiiq.com</a> | <a href="https://privacy.afognak.com/" target="_blank">Privacy Statement</a> | <a href="https://privacy.afognak.com/california-consumer-privacy-act-ccpa-notice-at-collection/" target="_blank">CCPA Collection Notice</a> 
                </div>
            </div>
        </div>
    );
}

export default LandingPage;
